import React, { useEffect } from 'react';
import { Container, Row, Col, Image } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import contact1 from "../../../assets/images/contact/contact.png";
import service1 from "../../../assets/images/contact/service1.png";
import service2 from "../../../assets/images/contact/service2.png";
import service3 from "../../../assets/images/contact/service3.png";
import service4 from "../../../assets/images/contact/service4.png";
import AOS from "aos";

const Help = () => {
  useEffect(() => {
    AOS.init({ duration: 2000, },);
}, [])
  return (
    <>
      <section className='help_wrap'>
        <Container fluid>
          <Row>
            <Col sm={5} md={6} lg={5} xl={5}>
              <div className='help_title'>
                <h1>We are here to help</h1>
              </div>
              <div className='contact_description_wrap' data-aos='fade-right'>
                <div className='contact_details'>
                  <div className='contact_details_img'>
                    <Image src={service1} alt='contact details img' fluid />
                  </div>
                  <div className='contact_details_text'>
                    <h4>Support</h4>
                    <p>Our support team will do their best to answer your<br /> inquiries. Contact us at info@urbanyogalab.com</p>
                  </div>
                </div>
                <div className='contact_details'>
                  <div className='contact_details_img'>
                    <Image src={service2} alt='contact details img' fluid />
                  </div>
                  <div className='contact_details_text'>
                    <h4>Sales</h4>
                    <p>Please contact us to arrange a discovery call<br /> blaine.howard@urbanyogalab.com</p>
                  </div>
                </div>
                <div className='contact_details'>
                  <div className='contact_details_img'>
                    <Image src={service3} alt='contact details img' fluid />
                  </div>
                  <div className='contact_details_text'>
                    <h4>Careers</h4>
                    <p>If you are a wellbeing expert, you can apply to <br /> join our team by sending us your CV and a<br /> letter of motivation to info@urbanyogalab.com</p>
                  </div>
                </div>
                <div className='contact_details'>
                  <div className='contact_details_img'>
                    <Image src={service4} alt='contact details img' fluid />
                  </div>
                  <div className='contact_details_text'>
                    <h4>Free Wellbeing Consultation</h4>
                    <p>Book a 20 minutes 1:1 discovery call with our<br /> founder ak@urbanyogalab.com</p>
                  </div>
                </div>
                <div className='contact_details_img_bg'>
                  <Image src={contact1} alt='contact' fluid />
                </div>
              </div>
            </Col>
            <Col sm={6} md={6} lg={6} xl={6}>
              <div className='contact_form_wrap'>
                <div className="pricing-from-sec" data-aos='fade-left'>
                  <form action="">
                    <div className=" pricing-inputs-div">
                      <div className="">
                        <label htmlFor="name">Your name</label>
                      </div>
                      <input
                        className="inputs-text"
                        type="text"
                        name="name"
                        defaultValue="Johnatan Sn"
                      />
                    </div>
                    <div className=" pricing-inputs-div">
                      <div className="mt-4">
                        <label htmlFor="email">Email</label>
                      </div>
                      <input
                        className="inputs-text"
                        type="email"
                        name="email"
                      />
                    </div>
                    <div className=" pricing-inputs-div">
                      <div className="mt-4">
                        <label htmlFor="name">Phone number</label>
                      </div>
                      <PhoneInput
                        inputClass="know-schedule-inputs"
                        enableSearch={true}
                        country={"gb"}
                      />
                    </div>



                    <div className=" pricing-inputs-div">
                      <div className="mt-4">
                        <label htmlFor="name">Company name</label>
                      </div>
                      <input className="inputs-text" type="text" name="name " />
                    </div>

                    <div className=" pricing-inputs-div">
                      <div className="mt-4">
                        <label htmlFor="name">
                          Your message
                        </label>
                      </div>
                      <textarea  name="message" className="inputs-text inputs-message" rows="4" cols="50">
                      </textarea>
                    </div>


                    <div className="pricing-inputs-div d-flex mt-5">
                      <div>
                        <div class="container">
                          <div class="round">
                            <input type="checkbox" id="checkbox" />
                            <label for="checkbox"></label>
                          </div>
                        </div>
                      </div>
                      <div className="pricing-check-text  ms-3">
                        By filling in this form you are opting in to receive our HR
                        insights, resources and webinars straight into your inbox.
                        You are able to change your preferences at anytime.
                      </div>
                    </div>

                    <div className=" pricing-inputs-div">
                      <div className="mt-4">
                        <button className="">Get a quote</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Help